// src/hooks/useChatConfiguration.js

import { useCallback, useState } from 'react';

export const useChatConfiguration = (configProps, onSaveConfig) => {
  const [notification, setNotification] = useState({ show: false, message: '' });

  const updateConfig = useCallback(() => {
    // Only proceed if onSaveConfig is provided (platform mode)
    if (!onSaveConfig) {
      return;
    }

    const updatedConfig = {
      assistantName: configProps.assistantName,
      messagePrompt: configProps.messagePrompt,
      introMessageText: configProps.introMessageText,
      headerColor: configProps.headerColor,
      chatBackgroundColor: configProps.chatBackgroundColor,
      botMessageBoxColor: configProps.botMessageBoxColor,
      botMessageTextColor: configProps.botMessageTextColor,
      userMessageBoxColor: configProps.userMessageBoxColor,
      userMessageTextColor: configProps.userMessageTextColor,
      responseDelay: configProps.responseDelay,
      openChatOnLoad: configProps.openChatOnLoad,
      chatOpenDelay: configProps.chatOpenDelay,
      showPoweredBy: configProps.showPoweredBy,
      showLinkPreviews: configProps.showLinkPreviews,
      widgetPosition: configProps.widgetPosition,
      announcement: configProps.announcement,
      // Include Toggle Button settings
      toggleButtonSize: configProps.toggleButtonSize,
      toggleButtonIcon: configProps.toggleButtonIcon,
      customToggleButtonIcon: configProps.customToggleButtonIcon,
      toggleButtonIconSize: configProps.toggleButtonIconSize,
      toggleButtonBackgroundColor: configProps.toggleButtonBackgroundColor,
      toggleButtonOutlineEnabled: configProps.toggleButtonOutlineEnabled,
      toggleButtonOutlineColor: configProps.toggleButtonOutlineColor,
      // Include WooCommerce feature flags only
      wooCommerceEnabled: configProps.wooCommerceEnabled,
      orderTrackingEnabled: configProps.orderTrackingEnabled,
      botTagline: configProps.botTagline,
      headerStyle: configProps.headerStyle,
      botIconUrl: configProps.botIconUrl,
      menuItems: configProps.menuItems,
      // Include only boolean flags for sensitive features
      hasCustomAssistant: configProps.hasCustomAssistant,
      hasCustomApiKey: configProps.hasCustomApiKey
    };

    onSaveConfig(updatedConfig);
  }, [configProps, onSaveConfig]);

  // Function to show notifications
  const showNotification = (message) => {
    setNotification({ show: true, message });

    // Hide notification after 3 seconds
    setTimeout(() => {
      setNotification({ show: false, message: '' });
    }, 3000);
  };

  // Function to get contrast color for styling
  const getContrastColor = (hexColor) => {
    hexColor = hexColor.replace('#', '');
    let r, g, b;
    if (hexColor.length === 3) {
      r = parseInt(hexColor[0] + hexColor[0], 16);
      g = parseInt(hexColor[1] + hexColor[1], 16);
      b = parseInt(hexColor[2] + hexColor[2], 16);
    } else if (hexColor.length === 6) {
      r = parseInt(hexColor.substring(0, 2), 16);
      g = parseInt(hexColor.substring(2, 4), 16);
      b = parseInt(hexColor.substring(4, 6), 16);
    } else {
      return '#757575';
    }

    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness > 180 ? '#757575' : '#FFFFFF';
  };

  return {
    updateConfig,
    notification,
    showNotification,
    getContrastColor
  };
}; 